import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { SOM_FICHEROS } from 'path-models/SOM_FICHEROS';
import { IncidenciaImageModel } from '../../models/incidencia-imatge.model';
import { PhotoBoxGalleryComponent } from 'path-shared/components/photo-box/components/photo-box-gallery/photo-box-gallery.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ImagesService } from 'path-shared/services/images/images.service';
import { ConfirmationDialogService } from 'path-shared/components/confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { DenunciesService } from 'path-denuncies-services/denuncies.service';

@Component({
  selector: 'app-incidencies-images',
  templateUrl: './incidencies-images.component.html',
  styleUrls: ['./incidencies-images.component.scss']
})
export class IncidenciesImagesComponent implements OnInit {

  arrayImages: string[] = [];
  somId: number;
  imageNames: string[] = [];
  imageContainer: IncidenciaImageModel[];
  images: SOM_FICHEROS[];
  contenedor: any;
  origen: string;
  files = [];
  numSelected = 0;


  @ViewChild('photoBoxGallery') photoBoxGallery: PhotoBoxGalleryComponent;
  @ViewChild('fileInput') fileInput: any;


  constructor(public thisDialogRef: MatDialogRef<IncidenciesImagesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private denunciesService: DenunciesService, 
    private imagesService: ImagesService,
    private confirmationDialogService: ConfirmationDialogService,
    private toastr: ToastrService,
    private i18n: I18n) {
        this.images = data['ficheros'];
        this.contenedor = data['contenedor'];
        this.origen = data['origen'];
        // images.forEach(element => { this.arrayImages.push(element.FICHERO); });

    }

  ngOnInit() {
  }

  // getImage(imageName: string) {

  //   const index = this.imageNames.indexOf(imageName);

  //   if (index === -1) {

  //     const image = this.denunciesService.getImage(this.somId, imageName).subscribe(
  //       detailsdata => {

  //         this.thisDialogRef.componentInstance.imageContainer = detailsdata;
  //         this.imageContainer.forEach(element => {

  //           this.arrayImages.push(element.FICHERO);
  //           this.imageNames.push(imageName);
  //         });
  //       });
  //   }
  // }
  Afegir() {
    const event = new MouseEvent('click', {bubbles: false});
    this.fileInput.file.nativeElement.dispatchEvent(event);
  }

  fileReady(files) {
    this.files = files;
    this.processar();
  }

  processar() {
    if (this.files === undefined || this.files === null) {
      this.toastr.warning(this.i18n('Cal seleccionar un fitxer per carregar!'));
    } else {

        const formData: FormData = new FormData();

        this.files.forEach(file => {
          formData.append('file', file, file.name);
        });

        // const object = [this.numDenuncia, formData];

        this.denunciesService.afegirImatgesWithContenedor(formData, this.origen, this.somId.toString()).subscribe(result => {
          this.imagesService.getImagesByContenedor(this.somId.toString()).subscribe( images => {
            this.images = images;
            this.images.forEach(element => {
              element.CONTENEDOR = this.contenedor;
            });
            this.photoBoxGallery.loadImages(this.images);
         });
          this.toastr.info(this.i18n('Imatges carregada correctament'));
        });

    }

  }



  getChildNumSelected(numSelected: number): void {

    this.numSelected = numSelected;
    if (this.numSelected === this.photoBoxGallery.selectedImages.length) {
      this.numSelected = 0;
    }
  }

  Eliminar() {

    this.confirmationDialogService.confirm(this.i18n('Confirmi'), this.i18n('Segur que vol eliminar les imatges seleccionades?'))
    .then((confirmed) => {
      if (confirmed) {
        this.photoBoxGallery.selectedImages.forEach(element => {

          if (element.checked === true) {

            this.denunciesService.deleteImage(element.imatge.SECURE_ID).subscribe(() => {
              const index: number = this.photoBoxGallery.selectedImages.indexOf(element);
              if (index !== -1) {
                this.photoBoxGallery.selectedImages.splice(index, 1);
              }

            });
          }
          this.numSelected = 0;
        });
      }
    });
  }
}
